import ViewRenderer from '../../web/viewrenderer/ViewRenderer';
export default ViewRenderer;
